import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrushIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brush"}/>
}
